import axios from 'axios';

export default function updatePerson(person, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.postPersons;
  return dispatch => dispatch({
    type: 'UPDATE_PERSON_SAVE',
    payload: axios({ method: 'post', url, headers, data: { person } })
  });
}


// WEBPACK FOOTER //
// ./src/actions/updatePerson.js